import * as ents from '@attain-apps/entities'
import * as graphql from '@attain-apps/fe/web/main/lib/graphql'

export const TRANSFORMER = graphql.transformers.OUT.enumeration<
  graphql.schema.TextAlignment,
  ents.extra.common.Report.Cell.TextAlignment
>({
  [graphql.schema.TextAlignment.Center]:
    ents.extra.common.Report.Cell.TextAlignment.Center,
  [graphql.schema.TextAlignment.Left]:
    ents.extra.common.Report.Cell.TextAlignment.Left,
  [graphql.schema.TextAlignment.Right]:
    ents.extra.common.Report.Cell.TextAlignment.Right,
})
